<template>
  <div class="medium-3 bg-white contact--panel">
    <div v-if="isLoading" class="loading-overlay">
      <div class="loading-spinner"></div>
      <div class="loading-text">Loading...</div>
    </div>
    <transition name="slide-fade">
      <client-informations
          v-if="layout === 'gen-info'"
          class="slide"
          :contact="contact"
          :key="currentID"
          :client-address="clientAddress"
          :client-name="clientName"
          :client-email="clientEmail"
          :client-phone-number="clientPhoneNumber"
          :client-gender="clientGender"
          :client-age="clientAge"
          :edit-url="clientEditUrl"
          :client-contracts-count="clientContractsCount"
          :client-sinisters-count="clientSinistersCount"
          :client-claims-count="clientClaimsCount"
          :client-automobile-contracts-count="clientAutomobileContractsCount"
          :client-incendie-contracts-count="clientIncendieContractsCount"
          :client-transport-contracts-count="clientTransportContractsCount"
          :client-var-risks-contracts-count="clientVarRisksContractsCount"
          :client-health-contracts-count="clientHealthContractsCount"
          :client-life-contracts-count="clientLifeContractsCount"
          :client-special-risks-contracts-count="clientSpecialRisksContractsCount"
          :client-rc-contracts-count="clientRcContractsCount"
      >
      </client-informations>
      <Contracts
          v-if="layout === 'Fidelity'"
          class="slide"
          :key="currentID"
          :client-all-contracts="clientAllContracts"
          :is-loading="isLoading"
      >
      </Contracts>
      <Sinisters
          v-if="layout === 'Orders'"
          class="slide"
          :key="currentID"
          :client-all-sinisters="clientAllSinisters"
          :customerEmail="contact.email"
          :is-loading="isLoading"
      >
      </Sinisters>
      <AssuranceComplaints
          v-if="layout === 'Complaints'"
          class="slide"
          :key="currentID"
          :client-all-claims="clientAllClaims"
          :is-loading="isLoading"
      >
      </AssuranceComplaints>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import GeneralInfoVue from "./GeneralInfoContent";
import OrdersContent from "./OrdersContent";
import FidelityContentVue from "./FidelityContent";
import Sinisters from "../../../components/widgets/conversation/AssuranceBlock/Sinisters"
import Contracts from "../../../components/widgets/conversation/AssuranceBlock/Contracts"
import AssuranceComplaints from "../../../components/widgets/conversation/AssuranceBlock/AssuranceComplaints"
import ComplaintsContent from "./ComplaintsContent"
import ClientInformations from "../../../components/widgets/conversation/RetailBlocks/ClientInformations";
import OrdersBlock from "../../../components/widgets/conversation/RetailBlocks/OrdersBlock";


export default {
  components: {
    OrdersBlock,
    ClientInformations,
    ComplaintsContent,
    FidelityContentVue,
    OrdersContent,
    GeneralInfoVue,
    Contracts,
    Sinisters,
    AssuranceComplaints
  },
  props: {
    conversationId: {
      type: [Number, String],
      required: true,
    },
    inboxId: {
      type: Number,
      default: undefined,
    },
    onToggle: {
      type: Function,
      default: () => { },
    },
    layout: {
      type:String,
      default: "gen-info"
    } ,
    currentID: Number
  },
  data() {
    return {
      isLoading: false,
      dragEnabled: true,
      conversationSidebarItems: [],
      dragging: false,
      customerData: {
        serialNumber: 0,
        email: '',
        address: '',
        name:'',
        phoneNumber: '',
        gender: '',
        age: 0,
        editUrl: '',
        currentContractsCount: 0,
        currentSinistersCount: 0,
        currentClaimsCount: 0,
      },
      currentContractsCount: {
        automobile: 0,
        incendie: 0,
        transport: 0,
        variousRisks: 0,
        health: 0,
        life: 0,
        specialRisks: 0,
        rc: 0
      },
      allContracts: [],
      allSinisters: [],
      allClaims: [],
    };
  },
  computed: {
    ...mapGetters({
      currentChat: 'getSelectedChat',
      currentUser: 'getCurrentUser',
      uiFlags: 'inboxAssignableAgents/getUIFlags',
    }),
    conversationAdditionalAttributes() {
      return this.currentConversationMetaData.additional_attributes || {};
    },
    channelType() {
      return this.currentChat.meta?.channel;
    },
    contact() {
      return this.$store.getters['contacts/getContact'](this.contactId);
    },
    contactAdditionalAttributes() {
      return this.contact.additional_attributes || {};
    },
    contactId() {
      return this.currentChat.meta?.sender?.id;
    },
    currentConversationMetaData() {
      return this.$store.getters[
          'conversationMetadata/getConversationMetadata'
          ](this.conversationId);
    },
    hasContactAttributes() {
      const {custom_attributes: customAttributes} = this.contact;
      return customAttributes && Object.keys(customAttributes).length;
    },
    clientAddress() {
      return this.customerData.address;
    },
    clientEmail() {
      return this.customerData.email;
    },
    clientName() {
      return this.customerData.name;
    },
    clientPhoneNumber() {
      return this.customerData.phoneNumber;
    },
    clientGender() {
      return this.customerData.gender;
    },
    clientAge() {
      return this.customerData.age;
    },
    clientEditUrl() {
      return this.customerData.editUrl;
    },
    clientContractsCount() {
      return this.customerData.currentContractsCount;
    },
    clientSinistersCount() {
      return this.customerData.currentSinistersCount;
    },
    clientClaimsCount() {
      return this.customerData.currentClaimsCount;
    },
    clientAutomobileContractsCount() {
      return this.currentContractsCount.automobile;
    },
    clientIncendieContractsCount() {
      return this.currentContractsCount.incendie;
    },
    clientTransportContractsCount() {
      return this.currentContractsCount.transport;
    },
    clientVarRisksContractsCount() {
      return this.currentContractsCount.variousRisks;
    },
    clientHealthContractsCount() {
      return this.currentContractsCount.health;
    },
    clientLifeContractsCount() {
      return this.currentContractsCount.life;
    },
    clientSpecialRisksContractsCount() {
      return this.currentContractsCount.specialRisks;
    },
    clientRcContractsCount() {
      return this.currentContractsCount.rc;
    },
    /* to return all the current contracts */
    clientAllContracts() {
      return this.allContracts;
    },
    /* to return all the current sinisters */
    clientAllSinisters() {
      return this.allSinisters;
    },
    /* to return all the current claims */
    clientAllClaims() {
      return this.allClaims;
    }
  },
  watch: {
    conversationId(newConversationId, prevConversationId) {
      if (newConversationId && newConversationId !== prevConversationId) {
        this.getContactDetails();
      }
    },
    contactId() {
      this.getContactDetails();
    },
  },
  mounted() {
    this.conversationSidebarItems = this.conversationSidebarItemsOrder;
    this.getContactDetails();
    this.$store.dispatch('attributes/get', 0);
    if (this.contact.cin && this.contact.birth_date) {
      this.getIdentityByCin(this.contact.cin, this.contact.birth_date);
    }
    if (this.contact.cin) {
      this.getClientClaims(this.contact.cin);
      this.getRedirectUrl(this.contact.cin);
    }
  },
  methods: {
    onPanelToggle() {
      this.onToggle();
    },
    getContactDetails() {
      if (this.contactId) {
        this.$store.dispatch('contacts/show', {id: this.contactId});
      }
    },
    getAttributesByModel() {
      if (this.contactId) {
        this.$store.dispatch('contacts/show', {id: this.contactId});
      }
    },
    openTranscriptModal() {
      this.showTranscriptModal = true;
    },
    onDragEnd() {
      this.dragging = false;
      this.updateUISettings({
        conversation_sidebar_items_order: this.conversationSidebarItems,
      });
    },
    /* to return the serial number by the customer cin if he exists */
    async getIdentityByCin(cin, birthDate) {
      const {appLogicURL} = window.convergenceConfig;
      const response = await axios.get(`${appLogicURL}/insurance-apis/getIdentityByCin`, {
        params: {
          identifiant: cin,
          date_naissance: birthDate,
          type_identifiant: 0,
        },
      });
      if (response.data.matricule_client) {
        this.customerData.serialNumber = response.data.matricule_client;
        this.customerData.phoneNumber = response.data.phone_number;
        await this.getClientPersonalData(this.customerData.serialNumber);
        await this.getClientContracts(this.customerData.serialNumber);
        await this.getClientSinisters(this.customerData.serialNumber);
        await this.getProductFamilyContracts(this.customerData.serialNumber);
      }
    },
    /* to return the customer personal data by its serial number */
    async getClientPersonalData(serialNumber) {
      this.isLoading = true;
      try {
        const {appLogicURL} = window.convergenceConfig;
        const response = await axios.get(`${appLogicURL}/insurance-apis/GetClientPersonalData`, {
          params: {
            matricule_client: serialNumber,
          },
        });
        // The returned address data
        const addressData = response.data.adresse;
        this.customerData.name = response.data.Prenom + " " + response.data.Nom;
        this.customerData.address = addressData.Rue1 !== "" ? `${addressData.Rue1}${addressData.Gouvernorat}` : (addressData.Rue2 !== "" ? `${addressData.Rue2}${addressData.Gouvernorat}` : addressData.Gouvernorat);
        this.customerData.email = response.data.email;
        this.customerData.gender = response.data.genre;
        await this.calculateAge(response.data.birthday);
      } catch (error) {
        console.error('Error fetching client personal data:', error);
      } finally {
        this.isLoading = false;
      }
    },
    calculateAge(birthday) {
      const birthYear = birthday.split('/')[2].split(' ')[0];
      const birthMonth = birthday.split('/')[1];
      const birthDay = birthday.split('/')[0];
      const currentDate = new Date();
      let age = currentDate.getFullYear() - birthYear;
      // Check if the birthday has already passed this year
      if (currentDate.getMonth() < birthMonth ||
          (currentDate.getMonth() === birthMonth && currentDate.getDate() < birthDay)) {
        age--;
      }
      this.customerData.age = age;
    },
    /* to return the url for edit the client */
    async getRedirectUrl(cin) {
      this.isLoading = true;
      try {
        const {appLogicURL} = window.convergenceConfig;
        const response = await axios.get(`${appLogicURL}/gat/ticketUrl`, {
          params: {
            numero: cin,
          },
        });
        let redirectUrl = response.data.RedirectUrl;
        this.customerData.editUrl = redirectUrl;
      } catch (error) {
        console.error('Error fetching redirect URL:', error);
      } finally {
        this.isLoading = false;
      }
    },
    /* to return the number of customer contracts in progress by its serial number */
    async getClientContracts(serialNumber) {
      this.isLoading = true;
      try {
        const {appLogicURL} = window.convergenceConfig;
        const response = await axios.get(`${appLogicURL}/insurance-apis/GetClientContrats`, {
          params: {
            matricule_client: serialNumber,
            etatPolice: 1,
          },
        });
        const contracts = response.data;
        this.customerData.currentContractsCount = contracts.length;
        this.allContracts = contracts;
      } catch (error) {
        console.error('Error fetching client contracts:', error);
      } finally {
        this.isLoading = false;
      }
    },
    /* to return the number of customer sinisters with all states by its serial number */
    async getClientSinisters(serialNumber) {
      this.isLoading = true;
      try {
        const {appLogicURL} = window.convergenceConfig;
        // Fetch sinisters without specifying etatPolice to get all states
        const response = await axios.get(`${appLogicURL}/insurance-apis/getAllSinistres`, {
          params: {
            matricule_client: serialNumber,
            // etatPolice parameter removed to get all sinisters
          },
        });

        // If the API requires etatPolice parameter, uncomment the following code
        // to fetch both states and combine results
        /*
        // Get sinisters with etatPolice=1
        const response1 = await axios.get(`${appLogicURL}/insurance-apis/getAllSinistres`, {
          params: {
            matricule_client: serialNumber,
            etatPolice: 1,
          },
        });

        // Get sinisters with etatPolice=2
        const response2 = await axios.get(`${appLogicURL}/insurance-apis/getAllSinistres`, {
          params: {
            matricule_client: serialNumber,
            etatPolice: 2,
          },
        });

        // Combine both results
        const sinisters = [...(response1.data || []), ...(response2.data || [])];
        */

        const sinisters = response.data || [];
        this.customerData.currentSinistersCount = sinisters.length;
        this.allSinisters = sinisters;
      } catch (error) {
        console.error('Error fetching client sinisters:', error);
      } finally {
        this.isLoading = false;
      }
    },
    /* to return the number of customer claims in progress by its serial number */
    async getClientClaims(cin) {
      this.isLoading = true;
      try {
        const {appLogicURL} = window.convergenceConfig;
        const response = await axios.get(`${appLogicURL}/insurance-apis/ticketDetails`, {
          params: {
            identifiant: cin,
          },
        });
        if (response.data.tickets !== null) {
          const claims = response.data.tickets;
          const activeClaims = claims.filter(claim => claim.statut === "Actif");
          this.customerData.currentClaimsCount = activeClaims.length;
          this.allClaims = activeClaims;
        }
      } catch (error) {
        console.error('Error fetching client claims:', error);
      } finally {
        this.isLoading = false;
      }
    },
    /* to return the number of current contracts by its product family */
    async getProductFamilyContracts(serialNumber) {
      this.isLoading = true;
      try {
        await this.getAutomobileContracts(serialNumber);
        await this.getIncendieContracts(serialNumber);
        await this.getTransportContracts(serialNumber);
        await this.getVarRisksContracts(serialNumber);
        await this.getHealthContracts(serialNumber);
        await this.getLifeContracts(serialNumber);
        await this.getSpecialRisksContracts(serialNumber);
        await this.getRcContracts(serialNumber);
      } catch (error) {
        console.error('Error fetching product family contracts:', error);
      } finally {
        this.isLoading = false;
      }
    },
    /* to return the number of current automobile contracts by its serial number */
    async getAutomobileContracts(serialNumber) {
      try {
        const {appLogicURL} = window.convergenceConfig;
        const response = await axios.get(`${appLogicURL}/insurance-apis/GetClientContrats`, {
          params: {
            matricule_client: serialNumber,
            etatPolice: 1,
            productFamily: 1,
          },
        });
        const automobileContracts = response.data;
        this.currentContractsCount.automobile = automobileContracts.length;
      } catch (error) {
        console.error('Error fetching automobile contracts:', error);
      }
    },
    /* to return the number of current incendie contracts by its serial number */
    async getIncendieContracts(serialNumber) {
      try {
        const {appLogicURL} = window.convergenceConfig;
        const response = await axios.get(`${appLogicURL}/insurance-apis/GetClientContrats`, {
          params: {
            matricule_client: serialNumber,
            etatPolice: 1,
            productFamily: 3,
          },
        });
        const incendieContracts = response.data;
        this.currentContractsCount.incendie = incendieContracts.length;
      } catch (error) {
        console.error('Error fetching incendie contracts:', error);
      }
    },
    /* to return the number of current transport contracts by its serial number */
    async getTransportContracts(serialNumber) {
      try {
        const {appLogicURL} = window.convergenceConfig;
        const response = await axios.get(`${appLogicURL}/insurance-apis/GetClientContrats`, {
          params: {
            matricule_client: serialNumber,
            etatPolice: 1,
            productFamily: 4,
          },
        });
        const transportContracts = response.data;
        this.currentContractsCount.transport = transportContracts.length;
      } catch (error) {
        console.error('Error fetching transport contracts:', error);
      }
    },
    /* to return the number of current various risks contracts by its serial number */
    async getVarRisksContracts(serialNumber) {
      try {
        const {appLogicURL} = window.convergenceConfig;
        const response = await axios.get(`${appLogicURL}/insurance-apis/GetClientContrats`, {
          params: {
            matricule_client: serialNumber,
            etatPolice: 1,
            productFamily: 5,
          },
        });
        const varRisksContracts = response.data;
        this.currentContractsCount.variousRisks = varRisksContracts.length;
      } catch (error) {
        console.error('Error fetching various risks contracts:', error);
      }
    },
    /* to return the number of current health contracts by its serial number */
    async getHealthContracts(serialNumber) {
      try {
        const {appLogicURL} = window.convergenceConfig;
        const response = await axios.get(`${appLogicURL}/insurance-apis/GetClientContrats`, {
          params: {
            matricule_client: serialNumber,
            etatPolice: 1,
            productFamily: 6,
          },
        });
        const healthContracts = response.data;
        this.currentContractsCount.health = healthContracts.length;
      } catch (error) {
        console.error('Error fetching health contracts:', error);
      }
    },
    /* to return the number of current life contracts by its serial number */
    async getLifeContracts(serialNumber) {
      try {
        const {appLogicURL} = window.convergenceConfig;
        const response = await axios.get(`${appLogicURL}/insurance-apis/GetClientContrats`, {
          params: {
            matricule_client: serialNumber,
            etatPolice: 1,
            productFamily: 7,
          },
        });
        const lifeContracts = response.data;
        this.currentContractsCount.life = lifeContracts.length;
      } catch (error) {
        console.error('Error fetching life contracts:', error);
      }
    },
    /* to return the number of current special risks contracts by its serial number */
    async getSpecialRisksContracts(serialNumber) {
      try {
        const {appLogicURL} = window.convergenceConfig;
        const response = await axios.get(`${appLogicURL}/insurance-apis/GetClientContrats`, {
          params: {
            matricule_client: serialNumber,
            etatPolice: 1,
            productFamily: 8,
          },
        });
        const specialRisksContracts = response.data;
        this.currentContractsCount.specialRisks = specialRisksContracts.length;
      } catch (error) {
        console.error('Error fetching special risks contracts:', error);
      }
    },
    /* to return the number of current special risks contracts by its serial number */
    async getRcContracts(serialNumber) {
      try {
        const {appLogicURL} = window.convergenceConfig;
        const response = await axios.get(`${appLogicURL}/insurance-apis/GetClientContrats`, {
          params: {
            matricule_client: serialNumber,
            etatPolice: 1,
            productFamily: 9,
          },
        });
        const rcContracts = response.data;
        this.currentContractsCount.rc = rcContracts.length;
      } catch (error) {
        console.error('Error fetching RC contracts:', error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~dashboard/assets/scss/variables';

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(1px);
}

.loading-text {
  margin-top: 10px;
  color: #483A9D;
  font-weight: 500;
  font-size: 14px;
  text-shadow: 0px 0px 5px rgba(255, 255, 255, 0.8);
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top: 3px solid #483A9D;
  border-right: 3px solid #483A9D;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

::-webkit-scrollbar {
  display: none;
}

.contact--panel {
  background: #FFFFFF;
  border: 0.5px solid #483A9D;
  box-shadow: 0px 3px 12px rgb(0 0 0 / 4%);
  border-radius: 8px 0px 8px 8px;
  //border-left: 1px solid var(--color-border);
  font-size: $font-size-small;
  overflow-y: auto;
  overflow: auto;
  position: relative;

  i {
    margin-right: $space-smaller;
  }
}

.list-group {
  .list-group-item {
    background-color: var(--white);
  }
}

::v-deep {
  .contact--profile {
    padding-bottom: var(--space-slab);
    border-bottom: 1px solid var(--color-border);
  }

  .conversation--actions .multiselect-wrap--small {
    .multiselect {
      padding-left: var(--space-medium);
      box-sizing: border-box;
    }

    .multiselect__element {
      span {
        width: 100%;
      }
    }
  }
}

.close-button {
  position: absolute;
  right: $space-two;
  top: $space-slab;
  font-size: $font-size-default;
  color: $color-heading;
  z-index: 9989;
}

.conversation--labels {
  padding: $space-medium;

  .icon {
    margin-right: $space-micro;
    font-size: $font-size-micro;
    color: #fff;
  }

  .label {
    color: #fff;
    padding: 0.2rem;
  }
}

.contact--mute {
  color: $alert-color;
  display: block;
  text-align: left;
}

.contact--actions {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.contact-info {
  margin-top: var(--space-two);
}

.contact--panel--container {
  //height: 1000px;
  height: 100%;
  width: 100%;
  border-radius: 8px 0px 8px 8px;
}

.slide {
  -webkit-transition: all 0.5s ease;
  transition: all 0.5s ease;
}

/* prefix with transition name */
.slide-fade-enter-active {
  opacity: 0;
  z-index: 10;
}

.slide-fade-leave-active {
  opacity: 0;
}

.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
}</style>
